import React from 'react';

import MUIAutocomplete, { AutocompleteProps } from '@material-ui/lab/Autocomplete';

import CloseIcon from '../../assets/icons/CloseIcon';
import useStyles from './styles';

const Autocomplete = ({ ...rest }: AutocompleteProps<any, any, any, any>) => {
  const classes = useStyles();

  return (
    <MUIAutocomplete
      ChipProps={{
        deleteIcon: <CloseIcon />,
        classes: {
          root: classes.chipRoot,
          label: classes.chipLabel,
          deleteIcon: classes.chipDeleteIcon,
        },
      }}
      {...rest}
    />
  );
};

export default Autocomplete;
